var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10463_75253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7666 20.2198L15.724 10.2247L15.7153 5.32224C15.7147 4.93474 15.3991 4.6203 15.0141 4.62098L9.88911 4.63001C9.50161 4.63069 9.18716 4.94625 9.18784 5.33375L9.19327 8.40874C9.19395 8.79624 9.5095 9.11069 9.897 9.11L14.3195 9.10221L14.3214 10.1797L10.8127 15.1834L8.85732 13.5443C8.70957 13.4021 8.50945 13.3325 8.30448 13.3503C8.09701 13.3682 7.9097 13.4785 7.79 13.6487L3.1917 20.2893C3.04208 20.5046 3.02507 20.7821 3.14798 21.0144C3.26839 21.2467 3.50615 21.3913 3.76865 21.3908L22.2061 21.3583L22.2261 21.3608L22.2386 21.3583C22.6161 21.3451 22.918 21.0346 22.9174 20.6546C22.9171 20.4971 22.8643 20.3447 22.7666 20.2198ZM20.8636 19.9557L5.11117 19.9835L8.4801 15.12L10.3679 16.6942C10.5006 16.8215 10.6732 16.8911 10.8582 16.8908C11.0457 16.8905 11.2206 16.8177 11.3554 16.6849L11.3678 16.6724L14.9614 11.5786L20.8636 19.9557ZM10.597 7.70377L10.5941 6.03377L14.3141 6.02721L14.317 7.69721L10.597 7.70377Z",
    fill: "#8E97A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10463_75253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2.96143 3.01733) rotate(-0.101015)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.d330a94d87518ed3d3e043ea129fc5ad.svg";
export { ForwardRef as ReactComponent };